import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

const SomuraSwitchField = ({
  labelLeft,
  labelRight,
  name,
  disabled,
  value,
  ...props
}) => {
  return (
    <FormControlLabel
      sx={{
        ...props.sx,
        "> span": {
          textTransform: "none",
          fontStyle: props.checked ? "normal" : "italic",
          color: props.checked
            ? props.sx?.color === "black"
              ? "text.reminder"
              : "text.main"
            : props.sx?.color === "black"
              ? "grey"
              : "text.disabled",
          // ...props.sx
        },
      }}
      label={props.label}
      labelPlacement="end"
      disabled={props.disabled}
      control={
        <Switch
          value={props.checked ? "on" : "off"}
          disabled={disabled}
          checked={props.checked}
          onChange={props.onChange}
          name={name}
          color={props.sx?.color === "black" ? "primary" : "secondary"}
        />
      }
    />
  );
};

export default SomuraSwitchField;
